module.exports = "<li ng-if=$ctrl.isEditing()> <a class=\"c-nav__list-item__anchor / t-navigation-link\" ng-click=$ctrl.stopEditing()>Logout</a> </li> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/widget/views/stopEditing.menu.html
// module id = 794
// module chunks = 0